import { Tables } from '~/types'
import { getWillieSupabaseClient } from '../../utils'

export const listUserOrgs = async (userId: string) => {
  const supabase = getWillieSupabaseClient()

  // List with * is fine because or RLS
  const { data: memberOrgsRes, error: memberError } = await supabase.from('org').select('*')

  if (memberError) {
    throw new Error(`Error fetching member organizations: ${memberError.message}`)
  }

  // Get orgs where user is the owner
  const { data: ownedOrgs, error: ownerError } = await supabase.from('org').select('*').eq('owner_id', userId)

  if (ownerError) {
    throw new Error(`Error fetching owned organizations: ${ownerError.message}`)
  }

  // Combine and deduplicate orgs
  const allOrgs = [...(memberOrgsRes?.flat() ?? []), ...(ownedOrgs ?? [])]
  const uniqueOrgs = Array.from(new Map(allOrgs.map((org) => [org.id, org])).values())

  return uniqueOrgs
}

type UpdateOrgPayload = Partial<Pick<Tables<'org'>, 'name' | 'owner_id' | 'icon_url'>>

export const updateOrg = async (orgId: string, data: UpdateOrgPayload) => {
  const supabase = getWillieSupabaseClient()
  const { error } = await supabase.from('org').update(data).eq('id', orgId)

  if (error) {
    console.error('Error updating org', error)
  }
}

export type OrgAssetMeta = {
  path: string
  name: string
}

export const uploadOrgAsset = async (orgID: string, file: File, prefix: string = '/'): Promise<OrgAssetMeta> => {
  const supabase = getWillieSupabaseClient()
  if (!prefix.startsWith('/')) {
    prefix = `/${prefix}`
  }

  const { data, error } = await supabase.storage
    .from('org_content')
    .upload(`${orgID}${prefix}${file.name}`, file, { upsert: true })
  if (error) {
    console.error('Error uploading asset:', error)
    throw new Error('Error uploading asset')
  }

  return {
    path: data.path,
    name: file.name
  }
}

export const createOrg = async (name: string, ownerId: string) => {
  const supabase = getWillieSupabaseClient()
  const { data, error } = await supabase.from('org').insert({ name, owner_id: ownerId }).select('*').single()

  if (error) {
    console.error('Error creating organization:', error)
    throw new Error('Error creating organization')
  }

  return data
}
